import {toast} from "react-toastify"
import {DeliverableScanResult} from "../signalR"
import {DeliverableModel, REQUEST_STATUS, RequestObject} from "../../../types"
import {ErrorIcon, SuccessIcon} from "../../../assets/icons"
import {TFunction} from "i18next"

export function RequestsQueueFunctions(t: TFunction<"translation", undefined>) {
  const executeRequest = (
    requestItem: RequestObject,
    setTriggerQueueUpdate: (
      value: React.SetStateAction<{
        isUpdate: boolean
        item: DeliverableModel | null
        index: number | null
        success: boolean | undefined
      }>,
    ) => void,
  ) => {
    fetch(requestItem.url, {
      method: requestItem.method,
      headers: requestItem.headers,
      body: requestItem.body,
    })
      .then((res) => {
        if (res.ok === false) {
          throw new Error()
        }
        return res.json()
      })
      .then(async (res: DeliverableModel[] | undefined) => {
        setTriggerQueueUpdate({
          isUpdate: true,
          item: res && res.length > 0 ? res[0] : null,
          index: 0,
          success: true,
        })

        if (requestItem.callbackFunction) {
          if (res && res[0]) await requestItem.callbackFunction(res[0])
        }
      })
      .catch(() => {
        toast.error(t("There are some issues with the progress"), {
          autoClose: 3000,
          icon: ErrorIcon,
          toastId: "request-queue-error-toast",
        })

        setTriggerQueueUpdate({
          isUpdate: true,
          item: null,
          index: 0,
          success: false,
        })
      })
  }

  const executeSignalRUpdate = (
    updateSignalRResult: DeliverableScanResult | null,
    requestsQueue: RequestObject[],
    completedRequests: RequestObject[],
    setUpdateQueue: (queue: Array<RequestObject>) => void,
    setUpdateCompletedRequests: (array: Array<RequestObject>) => void,
    setIsBusy: (isBusy: boolean) => void,
  ) => {
    if (!updateSignalRResult) return

    const itemIndex = requestsQueue.findIndex(
      (el) =>
        el.state == REQUEST_STATUS.SIGNALR &&
        el.id == updateSignalRResult.itemId,
    )

    if (itemIndex < 0) return

    const item = requestsQueue[itemIndex]

    if (updateSignalRResult.result == "No threats found") {
      item.state = REQUEST_STATUS.COMPLETED

      toast.success(t("Items completed successfully"), {
        autoClose: 3000,
        icon: SuccessIcon,
        toastId: "request-queue-toast",
        className: "toast toast-success",
        style: {borderLeft: "8px solid #58a733"},
      })
    } else {
      item.state = REQUEST_STATUS.FAILED

      toast.error(t("There are some issues with the progress"), {
        autoClose: 3000,
        icon: ErrorIcon,
        toastId: "request-queue-error-toast",
      })
    }

    setUpdateCompletedRequests([...completedRequests, item])
    const newQueue = requestsQueue.slice(0)
    newQueue.splice(itemIndex, 1)
    setUpdateQueue([...newQueue])
    setIsBusy(false)
  }
  return {
    executeRequest,
    executeSignalRUpdate,
  }
}
